import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ConnectionService } from './connection.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DateRange, Transaction, TransactionType } from '@contracts/interfaces/transaction.interfaces';
import { EbayRevenueDialogComponent } from '../dialogs/ebay-revenue-dialog/ebay-revenue.dialog';
import { MatDialog } from '@angular/material/dialog';
import { SquareRevenueDialogComponent } from '../dialogs/square-revenue-dialog/square-revenue.dialog';
import { TransactionDialogComponent } from '../dialogs/transaction-dialog/transaction.dialog';
import { ExpensesTaxFiguresDialogComponent } from '../dialogs/expenses-tax-figures/expenses-tax-figures.dialog';
import { ACCOUNT } from '../accounts';
import { CashDialogComponent } from '../dialogs/cash-dialog/cash.dialog';
import { TransactionQuery } from '@contracts/interfaces/transaction.interfaces'

@Injectable({
  providedIn: 'root'
})
export class TransactionsService {

  public transactions: Transaction[] = [];

  constructor(
      private http: HttpClient,
      private connectionService: ConnectionService,
      public dialog: MatDialog) {}

  getCurrentWeek(account?: string, onlyDebits: boolean = false) {
    const params: any = {};
    if (account) {
      params.account = account;
    }
    if (onlyDebits) {
      params.onlyDebits = true;
    }

    return this.http.get<{
      dateRange: { start: string; end: string },
      transactions: Transaction[]
    }>(this.connectionService.address + "/transaction-service/current-week", { params });
  }

  find(find: any, start?: number, limit?: number, sort?: any, includeIgnored?: boolean): Observable<Transaction[]> {

    return this.http.post(this.connectionService.address + "/transaction-service/find", {
      find, start, limit, sort, includeIgnored
    }).pipe(
      map((transactions: any) => {
      return transactions;
    }));
  }

  search(queryString: string, dateRange: DateRange, account: any): Observable<Transaction[]> {
    return this.http.post(this.connectionService.address + "/transaction-service/search", {
      queryString,
      dateRange,
      account
    }).pipe(
      map((transactions: any) => {
      return transactions;
    }));
  }

  find2(transactionQuery: TransactionQuery): Observable<Transaction[]> {
    return this.http.post<Transaction[]>(this.connectionService.address + "/transaction-service/find2", {
      transactionQuery
    });
  }

  get(sha1: string): Observable<Transaction> {
    return this.http.post<Transaction>(this.connectionService.address + "/transaction-service/get", {
      sha1
    });
  }

  checkIfExists(sha1: string) {
    return this.http.post(this.connectionService.address + "/transaction-service/check-if-exists", {
      sha1
    });
  }

  insert(transaction: Transaction) {
    return this.http.post(this.connectionService.address + "/transaction-service/insert", {
      transaction
    });
  }

  update(transaction: Transaction) {
    return this.http.post(this.connectionService.address + "/transaction-service/update", {
      transaction
    });
  }

  delete(transaction: Transaction) {
    return this.http.post(this.connectionService.address + "/transaction-service/delete", {
      transaction: transaction
    }) 
  }

  attachInvoice(transaction: Transaction, invoiceHash: string, invoiceNumber: any, allowAlreadyAttached = false) {
    return this.http.post(this.connectionService.address + "/transaction-service/copy-receipt", {
      invoiceHash,
      transaction,
      invoiceNumber,
      allowAlreadyAttached
    })
  }
  
  calculateVAT(amount: number): number {
    let VAT = 0;
    VAT = amount / 11;
    VAT = Math.round(VAT);
    return VAT;
  }

  paginationData(find: any) {
    return this.http.post(this.connectionService.address + "/transaction-service/pagination-data", {
      find
    })
  }

  infoData(query: any) {
    return this.http.post(this.connectionService.address + "/transaction-service/info-data", {
      query
    })
  }


  public getTransactionType(transaction: Transaction) {
    switch (transaction.source.account) {
      case ACCOUNT.EXPENSES:
        return TransactionType.Expense;
      case ACCOUNT.G72EXPENSES:
        return TransactionType.Expense;
      case ACCOUNT.REVENUE:
        return TransactionType.Revenue;
    }
  }

  public openTransactionDialog(type: TransactionType | null, transactionHash: string, index: number, dataSource: any, callback: any) {
    return this.get(transactionHash).subscribe((result) => {
        let dialog = this.dialog.open(TransactionDialogComponent, {
            height: '100vh',
            width: '90vw',
            maxHeight: '100%',
            maxWidth: '90vw',
            data: {
                type: this.getTransactionType(result),
                transactionHash,
                index,
                dataSource
            }
        });

        dialog.afterClosed().subscribe(r => {
            callback(r);
        })
    });
}

openExpensesTaxFiguresDialog(dateRange: DateRange, callback: any) {
  let dialog = this.dialog.open(ExpensesTaxFiguresDialogComponent, {
    autoFocus: false,
    width: '900px',
    data: {
      dateRange
    }
  });

  dialog.afterClosed().subscribe(data => {
    callback(data);
  })
}

  openEbayRevenueDialog(transaction: Transaction, callback: any) {
    let dialog = this.dialog.open(EbayRevenueDialogComponent, {
      autoFocus: false,
      width: '900px',
      data: {
        transaction
      }
    });

    dialog.afterClosed().subscribe(data => {
      callback(data);
    })
  }

  openSquareRevenueDialog(transaction: Transaction, callback: any) {
    let dialog = this.dialog.open(SquareRevenueDialogComponent, {
      autoFocus: true,
      width: '900px',
      data: {
        transaction
      }
    });

    dialog.afterClosed().subscribe(data => {
      callback(data)
    })
  }

  openCashRevenueDialog(transaction: Transaction, callback: any) {
    let dialog = this.dialog.open(CashDialogComponent, {
      autoFocus: true,
      width: '380px',
      data: {
        transaction
      }
    });

    dialog.afterClosed().subscribe(data => {
      callback(data)
    })
  }
}
